import React from 'react';
import { Microscope, X, Check, FlaskConical } from 'lucide-react';
export function FalseSolutions() {
  return <section className="py-16 px-4 bg-[#FEFCF6] text-center border-t border-[#E8DFD0]" data-id="element-84">
      <div className="max-w-[800px] mx-auto" data-id="element-85">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#2C1810] mb-2" data-id="element-86">
          ¿Por Qué Todo Lo Que Has Intentado Antes Ha Fallado?
        </h2>
        <div className="flex items-center justify-center gap-2 text-[#2D5A3D] font-medium mb-10" data-id="element-87">
          <Microscope className="w-5 h-5" data-id="element-88" />
          <span data-id="element-89">La Verdad que Nadie te Cuenta sobre los Suplementos</span>
        </div>

        {/* Comparison Table */}
        <div className="bg-white rounded-xl shadow-sm border border-[#E8DFD0] overflow-hidden mb-12" data-id="element-90">
          <div className="grid grid-cols-2 bg-[#F0F4EC] border-b border-[#E8DFD0]" data-id="element-91">
            <div className="p-4 font-bold text-[#5C4A3A] text-xs md:text-sm uppercase tracking-wider" data-id="element-92">
              Lo Que La Industria Vende
            </div>
            <div className="p-4 font-bold text-[#2D5A3D] text-xs md:text-sm uppercase tracking-wider bg-[#2D5A3D]/5" data-id="element-93">
              Lo Que Tu Cuerpo Necesita
            </div>
          </div>

          <div className="divide-y divide-[#E8DFD0]" data-id="element-94">
            {[{
            bad: 'Ingredientes aislados',
            good: 'Combinaciones sinérgicas'
          }, {
            bad: 'Dosis genéricas',
            good: 'Protocolos personalizados'
          }, {
            bad: 'Sin contexto de preparación',
            good: 'Métodos de extracción correctos'
          }, {
            bad: 'Marketing de marca',
            good: 'Ciencia de biodisponibilidad'
          }, {
            bad: 'Un síntoma a la vez',
            good: 'El sistema completo'
          }].map((row, i) => <div key={i} className="grid grid-cols-2 text-sm md:text-base" data-id="element-95">
                <div className="p-4 text-[#7F1D1D] flex items-center gap-2 justify-center md:justify-start" data-id="element-96">
                  <X className="w-4 h-4 shrink-0 opacity-50" data-id="element-97" />
                  <span data-id="element-98">{row.bad}</span>
                </div>
                <div className="p-4 text-[#14532D] font-medium bg-[#2D5A3D]/5 flex items-center gap-2 justify-center md:justify-start" data-id="element-99">
                  <Check className="w-4 h-4 shrink-0" data-id="element-100" />
                  <span data-id="element-101">{row.good}</span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Bio-Activation Principle - Simplified */}
        <div className="bg-[#2D5A3D] text-[#FEFCF6] p-8 rounded-2xl relative overflow-hidden text-left shadow-green-medium" data-id="element-102">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#4A8C5C] rounded-full blur-[80px] opacity-20 -translate-y-1/2 translate-x-1/2" data-id="element-103"></div>

          <div className="relative z-10" data-id="element-104">
            <div className="flex items-center gap-3 mb-6" data-id="element-105">
              <FlaskConical className="w-6 h-6 text-[#C17817]" data-id="element-106" />
              <h3 className="text-xl md:text-2xl font-serif font-bold" data-id="element-107">
                El Principio de Bio-Activación
              </h3>
            </div>

            <div className="flex flex-col md:flex-row gap-4 mb-6" data-id="element-108">
              <div className="bg-white/10 p-4 rounded-lg backdrop-blur-sm border border-white/10 flex-1" data-id="element-109">
                <p className="mb-1 opacity-80 text-xs uppercase tracking-wider" data-id="element-110">
                  Una hierba sola...
                </p>
                <p className="font-bold text-sm md:text-base" data-id="element-111">
                  ...puede rozar la cerradura.
                </p>
              </div>
              <div className="bg-[#C17817] p-4 rounded-lg shadow-lg flex-1 border border-[#FEFCF6]/20 transform md:scale-105" data-id="element-112">
                <p className="mb-1 text-[#FEFCF6]/90 text-xs uppercase tracking-wider" data-id="element-113">
                  Dos hierbas combinadas...
                </p>
                <p className="font-bold text-white text-sm md:text-base" data-id="element-114">
                  ...la abren de par en par.
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-4 border-t border-white/10" data-id="element-115">
              <p className="text-sm font-medium text-[#F0F4EC]" data-id="element-116">
                <span className="text-[#C17817] font-bold" data-id="element-117">
                  2,000% más absorción.
                </span>{' '}
                Confirmado por{' '}
                <em className="text-white" data-id="element-118">Frontiers in Pharmacology</em>.
              </p>
              <p className="text-xs md:text-sm font-bold text-[#C17817] text-center md:text-right" data-id="element-119">
                Esto no es medicina alternativa.
                <br data-id="element-120" />
                <span className="text-[#F0F4EC] font-normal" data-id="element-121">
                  Es química aplicada con ingredientes de tu cocina.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}